import { render, staticRenderFns } from "./EditTxtCamp.vue?vue&type=template&id=84bc9d0e"
import script from "./EditTxtCamp.vue?vue&type=script&lang=js"
export * from "./EditTxtCamp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports